"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragGrid = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_transition_group_1 = require("react-transition-group");
var DragGrid = function (props) { return (react_1.default.createElement(react_transition_group_1.CSSTransition, { mountOnEnter: true, unmountOnExit: true, in: props.isVisible, timeout: kaleidoscope_1.AnimationDuration.Medium, classNames: "drag-grid-wrapper-" },
    react_1.default.createElement("div", { className: "drag-grid-wrapper" },
        react_1.default.createElement("div", { className: "drag-grid", ref: props.dragGridRef }, props.gridColumns.map(function (columnRange, index) { return (react_1.default.createElement("div", { key: "".concat(columnRange, "-").concat(index), className: (0, classnames_1.default)([
                "drag-grid__item",
                "drag-grid__item--".concat(columnRange),
                {
                    "drag-grid__item--active": props.activeColumnRange === columnRange,
                },
            ]) })); }))))); };
exports.DragGrid = DragGrid;
